var _circle, _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorkage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26.5,
    stroke: "#D4D4D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0972 44.7622C25.6095 44.7622 23.7707 44.5866 22.5133 44.422C21.8167 44.3308 21.3203 43.7351 21.3203 43.0326V22.1799C21.3203 21.3367 24.4713 17.4533 24.4713 17.4533C24.4713 17.4533 24.9965 16.9281 24.9965 16.403V9.57573C24.9965 8.84131 25.5217 8.52539 26.8346 8.52539C28.2161 8.52539 28.6727 9.05056 28.6727 9.57573V16.403C28.6727 16.9281 28.6727 16.9281 29.1979 17.4533C30.0283 18.2837 32.3489 21.1295 32.3489 22.1799V43.0324C32.3489 43.7349 31.8529 44.3363 31.1578 44.4376C30.0607 44.5976 28.5378 44.7622 27.0972 44.7622Z",
    stroke: "currentColor",
    strokeWidth: 0.736842
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.3176,
    y: 23.0755,
    width: 5.04005,
    height: 17.119,
    rx: 0.368421,
    stroke: "currentColor",
    strokeWidth: 0.736842
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorkage);
export default __webpack_public_path__ + "static/media/corkage.158fdcbac116cc155dfb5876f559edd8.svg";
export { ForwardRef as ReactComponent };